import { Component, inject, signal } from '@angular/core';
import { form, FormField, required, submit } from '@angular/forms/signals';
import { MAT_DIALOG_DATA, MatDialogModule, MatDialogRef } from '@angular/material/dialog';
import { UiButtonComponent } from '@app/shared/ui/button/ui-button.component';

import { CompanyIndustriesDataService } from '@app/shared/services/company-industries-data.service';
import { CompanyIndustryEditDialogData } from '@app/shared/types/models/company-industry/company-industry-dto.model';
import { CompanyIndustryFormModel } from '@app/shared/types/models/company/company-industry.model';
import { UiDialogComponent } from '@app/shared/ui/dialog/ui-dialog.component';
import { UiInputComponent } from '@app/shared/ui/input/ui-input.component';
import { TranslatePipe } from '@ngx-translate/core';

@Component({
  selector: 'proffeo-edit-company-industry-dialog',
  imports: [MatDialogModule, TranslatePipe, UiDialogComponent, FormField, UiButtonComponent, UiInputComponent],
  templateUrl: './edit-company-industry-dialog.component.html'
})
export class EditCompanyIndustryDialogComponent {
  private readonly companyIndustriesDataService: CompanyIndustriesDataService = inject(CompanyIndustriesDataService);
  private readonly dialogRef: MatDialogRef<EditCompanyIndustryDialogComponent> = inject(
    MatDialogRef<EditCompanyIndustryDialogComponent>
  );
  private readonly dialogData: CompanyIndustryEditDialogData = inject(MAT_DIALOG_DATA);

  protected readonly model = signal<CompanyIndustryFormModel>({
    name: this.dialogData.companyIndustryToEdit.name ?? ''
  });
  protected readonly form = form(this.model, path => {
    required(path.name, { message: 'ui-forms-this-field-is-required' });
  });

  public save(): void {
    void submit(this.form, {
      action: async () => {
        const id = this.dialogData.companyIndustryToEdit.id;
        this.companyIndustriesDataService.updateCompanyIndustry(id, { id, name: this.model().name });
        this.dialogRef.close();
      }
    });
  }
}
